import { scrollLink } from './scroll-link.js'
import { getLinkTarget, throttle } from './util.js'

document.addEventListener('DOMContentLoaded', () => {
  const $sectionNav = document.querySelector('.section-nav')
  if (!$sectionNav) return

  const $headerContainer = document.querySelector('.header-container')
  const $header = $headerContainer?.querySelector('.header')
  const $wrapper = $sectionNav.querySelector('.section-nav__wrapper')
  const $links = $sectionNav.querySelectorAll('.section-nav__menu-link')

  let headerContainerHeight = 0
  let sectionNavHeight = 0
  let barHeight = 0
  let navOffsetTop = 0

  function measureBar() {
    // фон белого хедера на .header-container — меряем его, иначе возможен зазор
    headerContainerHeight = $headerContainer
      ? Math.round($headerContainer.getBoundingClientRect().height)
      : ($header?.offsetHeight || 0)
    sectionNavHeight = $sectionNav.offsetHeight
    barHeight = headerContainerHeight + sectionNavHeight
    navOffsetTop = $sectionNav.getBoundingClientRect().top + window.scrollY
  }

  const sectionMap = new Map()
  const sectionList = []
  let scrollSection = false
  let activeLink

  $links.forEach(($link) => {
    scrollLink(
      $link,
      () => barHeight,
      ($link, $section) => {
        $($links).removeClass('section-nav__menu-link--active')
        $($link).addClass('section-nav__menu-link--active')
        scrollSection = $section
      }
    )

    const $section = getLinkTarget($link)
    if (!$section) return
    sectionMap.set($section, $link)
    sectionList.push($section)
  })

  //* если секций нет, завершаем функцию
  if (!sectionList.length) return

  const $lastSection = sectionList[sectionList.length - 1]

  let toggle = true
  let windowScrollY = window.scrollY

  function scrollSectionNav() {
    //* Для фиксации wrapper
    if (window.scrollY > navOffsetTop - headerContainerHeight - 2) {
      if (toggle) {
        $wrapper.classList.add('section-nav__wrapper--fixed')
        $headerContainer?.classList.add('header-container--section-nav-fixed')
        toggle = false
      }
      // -2px: перекрытие, чтобы не было субпиксельного зазора с хедером
      $wrapper.style.top = Math.max(0, headerContainerHeight - 2) + 'px'
    } else {
      if (!toggle) {
        $wrapper.classList.remove('section-nav__wrapper--fixed')
        $headerContainer?.classList.remove('header-container--section-nav-fixed')
        $wrapper.style.top = '0px'
        toggle = true
      }
    }

    //* если последняя секция и activeLink не false - удаляем модификатор active у ссылки и перерываем функцию scrollSectionNav
    if ($lastSection.getBoundingClientRect().bottom - barHeight < 0 && activeLink !== false) {
      $(activeLink).removeClass('section-nav__menu-link--active')
      activeLink = false
      return
    }

    let direction
    windowScrollY <= window.scrollY ? (direction = true) : (direction = false)

    windowScrollY = window.scrollY

    direction ? scrollWindowUp() : scrollWindowDown()
  }

  function syncNav() {
    measureBar()
    scrollSectionNav()
  }

  syncNav()
  requestAnimationFrame(() => requestAnimationFrame(syncNav))
  window.addEventListener('load', syncNav)
  window.addEventListener('pageshow', syncNav)
  document.fonts?.ready.then(syncNav)
  const $observe = $header || $headerContainer
  if ($observe) new ResizeObserver(syncNav).observe($observe)

  const throttleScrollSectionNav = throttle(scrollSectionNav, 16)
  window.addEventListener('scroll', throttleScrollSectionNav)

  let toggleUpLink
  function scrollWindowUp() {
    let activeSection
    const screenHeight = window.innerHeight / 4

    for (let i = sectionList.length - 1; i >= 0; i--) {
      const $section = sectionList[i]
      const size = $section.getBoundingClientRect()

      if (
        size.top - window.innerHeight + (size.height > screenHeight ? screenHeight : size.height / 4) < 0 &&
        size.bottom - barHeight > 0
      ) {
        activeSection = $section
        break
      }
    }

    if (activeSection) {
      toggleUpLink = false
      parseLinkActive(activeSection)
    } else {
      if (!toggleUpLink) {
        toggleUpLink = true
        $(activeLink).removeClass('section-nav__menu-link--active')
        activeLink = false
      }
    }
  }

  let toggleDownLink
  function scrollWindowDown() {
    let activeSection
    let screenHeight = window.innerHeight / 4

    for (let i = 0; i < sectionList.length; i++) {
      const $section = sectionList[i]
      const size = $section.getBoundingClientRect()
      const localScreenHeight = size.height > screenHeight ? screenHeight : size.height / 4

      if (size.bottom - barHeight - localScreenHeight > 0 && size.top - window.innerHeight + localScreenHeight < 0) {
        activeSection = $section
        break
      }
    }

    if (activeSection) {
      toggleDownLink = false
      parseLinkActive(activeSection)
    } else {
      if (!toggleDownLink) {
        toggleDownLink = true
        $(activeLink).removeClass('section-nav__menu-link--active')
        activeLink = false
      }
    }
  }

  function parseLinkActive($section) {
    if (scrollSection === false) {
      const $link = sectionMap.get($section)
      if (activeLink !== $link) {
        $($links).removeClass('section-nav__menu-link--active')
        $($link).addClass('section-nav__menu-link--active')
        activeLink = $link

        if ($wrapper.clientWidth <= $wrapper.scrollWidth) {
          const wrapperWidth = $wrapper.getBoundingClientRect().width
          const linkSize = $link.getBoundingClientRect()

          let offset = 0
          if (linkSize.left < 0) offset = linkSize.left - 20
          else if ((linkSize.right - wrapperWidth) * -1 < 0) offset = linkSize.right - wrapperWidth + 20

          if (offset !== 0) {
            $wrapper.scrollBy({
              top: 0,
              left: Math.floor(offset),
              behavior: 'smooth',
            })
          }
        }
      }
    } else if ($section === scrollSection) {
      scrollSection = false
    }
  }

  $(window).on('resize:width', syncNav)
})
